


export const BLACKLIST_START = 'BLACKLIST_START';
export const BLACKLIST_END = 'BLACKLIST_END';
export const BLACKLIST_ERROR = 'BLACKLIST_ERROR';
export const BLACKLIST_SUCCESS = 'BLACKLIST_SUCCESS';
export const BLACKLIST_FAIL = 'BLACKLIST_FAIL';
export const BLACKLISTDROPDOWN_SUCCESS ='BLACKLISTDROPDOWN_SUCCESS';
export const BLACKLIST_ERRORMESSAGE = 'BLACKLIST_ERRORMESSAGE';